import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import LoadingSpinner from '../loadingSpinner/';
import Basket from './basket';

@inject('lineStore')
@observer
class BasketContainer extends Component {

  render() {

    if (!this.props.lineStore.basket.mode) return false;

    const { isLoading } = this.props.lineStore.basket;
    return (
      isLoading ?
        <div className="line-right-column-basket-cont b-l">
          <LoadingSpinner />
        </div> :
        <Basket />
    )
  }
}

export default BasketContainer;


// WEBPACK FOOTER //
// ./src/components/basket/index.js